import FormField from "components/FormField";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";

function Links({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setsuccess] = useState("");
  const [currentFormData, setcurrentFormData] = useState({
    privacy: formData?.privacy,
    terms_condition: formData?.terms_condition,
    community: formData?.community,
    help_center: formData?.help_center,
    video_tutorial: formData?.video_tutorial,
  });
  const [loadingButton, setLoadingButton] = useState(false);

  // Sync currentFormData with formData when formData changes
  useEffect(() => {
    if (formData) {
      setcurrentFormData(formData);
    }
  }, [formData]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setcurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setsuccess("");
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);
    const payload = {
      _id: currentFormData.id,
      privacy: currentFormData.privacy,
      terms_condition: currentFormData.terms_condition,
      community: currentFormData.community,
      help_center: currentFormData.help_center,
      video_tutorial: currentFormData.video_tutorial,
      agency_id: currentFormData.agency_id,
    };
    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      setLoadingButton(false);
      toast.success("Data updated Successfully");
    } else {
      toast.error("Error updating Data");
      setLoadingButton(false);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Privacy</label>
              <input
                className="form-control-agust"
                label="Privacy"
                onChange={handleChange}
                placeholder="Privacy"
                name="privacy"
                value={currentFormData.privacy}
              />
            </SoftBox>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Terms and Conditions</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Terms and Conditions"
                name="terms_condition"
                value={currentFormData.terms_condition}
              />
            </SoftBox>
          </div>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Community</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Community"
                name="community"
                value={currentFormData.community}
              />
            </SoftBox>

            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Help Center</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Help Center"
                name="help_center"
                value={currentFormData.help_center}
              />
            </SoftBox>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Embed Video (Enter YouTube Link)</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Video Tutorial"
                name="video_tutorial"
                value={currentFormData.video_tutorial}
              />
            </SoftBox>
          </div>
        </div>
        <div style={{ margin: "10px 0px", textAlign: "right" }}>
          <SoftButton
            disabled={loadingButton}
            type="submit"
            color="dark"
            className="px-2 py-1"
            style={{ background: "black", color: "white" }}
          >
            {loadingButton ? "Updating..." : "Update"}
          </SoftButton>
        </div>
      </form>
    </div>
  );
}

export default Links;
